import React from 'react'
import Button from '@material-ui/core/Button'
import { useIsAnyTimePickerPopoverOpen } from './time-picker-popover-open-registry'

const TimePickerPopoverSubmitButton = ({
  disabled,
  children,
  ...buttonProps
}) => {
  const isTimePickerPopoverOpen = useIsAnyTimePickerPopoverOpen()

  return (
    <Button
      {...buttonProps}
      disabled={Boolean(disabled) || isTimePickerPopoverOpen}
    >
      {children}
    </Button>
  )
}

export default TimePickerPopoverSubmitButton
